import { iconFactory } from './icon.factory.ts'

export default iconFactory(
    `<svg width="454" height="512" viewBox="0 0 454 512" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M227 0.0853271L453.133 128V383.915L227 511.829L0.866699 383.915V128L227 0.0853271Z" fill="white"/>
<path d="M412.771 375.04L234.509 475.989V397.483L345.613 336.299L412.771 375.04ZM424.973 364.032V153.088L359.779 190.72V326.4L424.973 364.032ZM40.5467 375.04L218.808 475.904V397.397L107.704 336.299L40.5467 375.04ZM28.344 364.032V153.088L93.5387 190.72V326.4L28.344 364.032ZM35.9387 139.435L218.808 36.0107V111.957L101.645 176.384L100.707 176.896L35.9387 139.435ZM417.293 139.435L234.509 36.0107V111.957L351.587 176.469L352.525 176.981L417.293 139.435Z" fill="#8ED6FB"/>
<path d="M218.808 379.563L109.24 319.232V199.851L218.808 263.083V379.563ZM234.509 379.563L344.077 319.317V199.851L234.509 263.083V379.563ZM116.579 186.027L226.659 125.525L336.653 186.027L226.659 249.515L116.579 186.027Z" fill="#1C78C0"/>
</svg>
`,
    (mesh, position) => {
        if (position <= 0) mesh.position.set(0, 0, 10)
    },
)
